// ZM - Reviewed by Claude Portal-Review Deep Dive 2026-05-22
import React, { useState, useCallback } from 'react';
import { IconButton, Dialog } from '@framework-controls/core';
import { IconInfo, IconRemove } from 'src/content/icons';
import * as css from './Information.module.scss';
import { ascCtaInteraction, ascPageview } from 'src/helpers/EventHelper/EventHelper';
import { VehicleRec, ascCtaInteractionInput, ascPageviewInput } from 'src/models';

interface IProps {
    headerLit: string;
    message?: string;
    children: React.ReactNode;
    vehicles: VehicleRec[];
    selectedVehicle?: string;
}

const Information = (props: IProps) => {
    // flag that deterermines if the Dialog is open or closed.
    const [menuOpenFlag, setMenuOpenFlag] = useState(false);

    // Invert the value of the open flag on DialogHandler.
    // This will either set to true (open) if currently false (close)
    // or  flase (close) if current true (open)
    const dialogHandler = useCallback((e: any) => {
        setMenuOpenFlag(!menuOpenFlag);
        if (!menuOpenFlag) {
            const ascPageViewInp: ascPageviewInput = {
                pageType: 'service',
                errorCode: '',
                itemResults: '',
            };
            ascPageview(ascPageViewInp, props.vehicles, props.selectedVehicle);
        }
        const ascCtaInteractionInp : ascCtaInteractionInput = {
            pageType: 'service',
            elementText: menuOpenFlag ? 'x' : 'i',
            elementColor: '',
            elementOrder: '',
            elementType: 'item_details',
            elementSubType: 'information_link',
            eventAction: 'click',
            eventActionResult: menuOpenFlag ? 'close' : 'open',
            linkUrl: '',
        };
        ascCtaInteraction(ascCtaInteractionInp, e, props.vehicles, props.selectedVehicle);
    }, [menuOpenFlag, props.vehicles, props.selectedVehicle]);

    return (
        <div>
            <IconButton
                id='infoBtn'
                onClick={dialogHandler}>
                <div>
                    <IconInfo />
                </div>
            </IconButton>
            <Dialog
                cssClasses={{
                    content: css.content,
                    paper: css.paper,
                    header: css.LightBoxHeader,
                }}
                isOpen={menuOpenFlag}
                anchorOrigin={{
                    vertical: 'top',
                }}
                header={<div>{props.headerLit}</div>}
                hideSave={true}
                hideCancel={true}
                disableUpperCase={true}
                onCancel={dialogHandler}
                onBackDropClick={dialogHandler}
                width='full'
            >
                <div className={css.headerbox}>
                    {props.headerLit}
                    <div className={css.headerIcon}>
                        <IconRemove id='closeBtn' onClick={dialogHandler}/>
                    </div>
                </div>
                {props.children}
            </Dialog>
        </div>
    );
};

export default Information;
